import { useQuery } from "@tanstack/react-query";
import { DEFAULT_SITE_SETTINGS } from "@alpha/shared";
import { api } from "./api";
import type { SiteSettings } from "./types";

/** The query key, exported so the admin mutation can invalidate it. */
export const SITE_SETTINGS_KEY = ["site-settings"] as const;

/** App-wide branding (issue #20). No auth: it feeds the nav and footer on every page. */
export function useSiteSettings() {
  return useQuery({
    queryKey: SITE_SETTINGS_KEY,
    queryFn: () => api.get<SiteSettings>("/public/settings"),
    staleTime: 60_000,
    retry: 1,
  });
}

/**
 * The app's own defaults while the query is loading or has never resolved, so
 * the nav and footer never render blank — they render the app's own brand
 * until an admin's customization arrives, same as the server does.
 */
export function useBranding(): SiteSettings {
  return useSiteSettings().data ?? DEFAULT_SITE_SETTINGS;
}
